import GroupsWidget from '@cont/Groups/GroupsWidget';
import { GroupsContext } from '@context/GroupsContext';
import useGroupsChangeStore from '@stores/groups/groupsChangeStore';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import GroupsOnboardingLoader from './GroupsLoader/GroupsOnboardingLoader';
import GroupsSkeletonLoader from './GroupsLoader/GroupsSkeletonLoader';

const GroupsContainer = () => {
  const {
    query: { goalUID }
  } = useRouter();

  const groupsContext = useContext(GroupsContext);
  const { isGroupsDataLoaded, groupUid } = groupsContext;
  const { isGroupNew } = useGroupsChangeStore();

  if (!isGroupsDataLoaded) {
    return isGroupNew ? <GroupsOnboardingLoader /> : <GroupsSkeletonLoader />;
  }

  return <GroupsWidget goalUID={goalUID as string} groupUID={groupUid} />;
};

export default GroupsContainer;
